import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss'],
})
export class ForbiddenComponent implements OnInit {
  code = '403';
  title = 'Access Denied';
  message = 'You are not authorized to access this page.';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly location: Location
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const msg = params?.['message'];
      if (typeof msg === 'string' && msg.trim()) {
        this.message = msg.trim();
      }
    });
  }

  goBack(): void {
    this.location.back();
  }
}


